import { TripDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import * as dayjs from 'dayjs';

type CriteriaType = "time" | "price" | "operator";

type Time = "MORNING" | "AFTERNOON" | "EVENING";
type Price = "Low to High" | "High to Low";
// type funcType = ((result)=> boolean) | ((a,b) => number);

interface FilterOption<K = any, V = any> {
    key: K,
    value: V,
    icon: string,
    type: string,
    getLabel:(messageProvider:MessageProvider)=>string
    // func:funcType
}


interface FilterOptionSelection {
    option: FilterOption,
    isSelected: boolean
}

export default class FilterCriteria {
    time: Time | null;
    price: Price | null;
    operator: string[];

    constructor(time: Time | null = null, price: Price | null = null, operator: string[]  = []) {
        this.time = time;
        this.price = price;
        this.operator = operator;
    }

    getTime(): Time | null {
        return this.time;
    }

    getPrice(): Price | null {
        return this.price;
    }

    getOperator():string[] {
        return this.operator;
    }

    setOperator(value:string[]):void {
        this.operator = [...value];
    }

    withTime(value: Time | null) {
        return new FilterCriteria(value, this.price, this.operator);
    }

    matches(result:TripDTO): boolean {
        // console.log(result.correlationId, dayjs(result.departureDateTime).format("A"));
        //let matchesTime: boolean = (this.time == null) || (dayjs(result.departure.scheduledAt).format("A") == this.time);
        let matchesTime: boolean = (this.time == null) || matchTimeRange(this.time, result);

        // let matchesOperator: boolean = (this.operator == null) || (result.operatorId == this.operator)
        let matchesOperator: boolean = this.operator.length == 0 || this.operator.includes(result.operator.id);
        return matchesTime && matchesOperator;
    }

    compare(a:TripDTO, b:TripDTO): number {
        if (this.price == "Low to High") {
            return a.priceRange.min.amount - b.priceRange.min.amount
        }
        else if (this.price == "High to Low") {
            return b.priceRange.min.amount - a.priceRange.min.amount
        }
        else {
            return 0;
        }
    }

}

function matchTimeRange(time:Time, tripResult:TripDTO):boolean {
    let hour:number = dayjs(tripResult.departure.scheduledAt).hour();
    if(time == 'MORNING') {
        return hour < 12;
    } else if(time == 'AFTERNOON') {
        return hour >= 12 && hour < 16;
    } else if(time == 'EVENING') {
        return hour >= 16
    } else {
        return true;
    }
}

let toFilterOptionSelections = (filterCriteria: FilterCriteria, filterOptions: FilterOption[]): FilterOptionSelection[] => {
    return filterOptions.map(option => {
        return {
            option: option,
            isSelected: option.value == filterCriteria.getTime() || option.value == filterCriteria.getPrice() || filterCriteria.getOperator().includes(option.value)
        }
    });
};

export { FilterOption,FilterCriteria, CriteriaType, Time, Price, FilterOptionSelection, toFilterOptionSelections };

